import { api } from "./api";

/**
 * Minimal first-party analytics. Privacy-conscious by design:
 * no cookies, no IP storage, no user identifiers — just event, path, label.
 * Fire-and-forget: never blocks UI, never throws.
 */
export function track(event, path, label) {
  try {
    api.post("/analytics/event", {
      event,
      path: path || window.location.pathname,
      label: label || "",
    }).catch(() => {});
  } catch {
    /* analytics must never break the app */
  }
}
